const routes = [
  { // 综合实训2.0
    path: "/training2",
    name: "training2",
    component: () => import('@/views/training2/index.vue'),
    children: [
      {//教师班课列表
        path: "/training2/teachClass",
        component: () => import('@/views/training2/class/teacherClass/index.vue'),
      },
      {//开课管理
        path: "/training2/courseAdmin",
        component: () => import('@/views/training2/class/schoolbegins/index.vue'),
      },
      {//学生班课列表
        path: "/training2/studentClass",
        component: () => import('@/views/training2/class/studentClass/index.vue'),
      },
      {//课程库
        path: "/training2/course",
        component: () => import('@/views/training2/course/index.vue'),
      },
      {//企业微课
        path: "/training2/microLecture",
        component: () => import('@/components/views/iframe/iframe.vue'),
      },
      {//应用中心
        path: "/training2/appCenter",
        component: () => import('@/components/views/appCenter/appCenter.vue'),
      },
      {//开课管理中创建班级
        path: "/training2/creatClass",
        component: () => import('@/views/training2/class/schoolbegins/components/creatClass.vue'),
      },
    ]
  },
]
export default routes;



// WEBPACK FOOTER //
// ./src/router/training2.js